import React, { forwardRef, PropsWithChildren, useEffect, useState } from 'react';
import styled from 'styled-components';
import { ICardProps } from './models';
import * as styles from './styles';
import { Shimmer } from '../shimmerAnimation/ShimmerAnimation';
import arrowDown from '../../assets/arrow-down.svg';
import arrowUp from '../../assets/arrow-up-blue.svg';
import { Icon } from '../icon/Icon';
import classNames from 'classnames';

const ExpandCardIcon = (selected: boolean) => {
  const iconType = selected ? arrowUp : arrowDown;
  return iconType;
};

export const Card = styled(
  forwardRef<HTMLDivElement, PropsWithChildren<ICardProps>>(
    (
      {
        className,
        children,
        appearance,
        isSelected,
        isInitialyExpanded,
        expandedContent,
        loaderContent,
        handleSelect,
        isDisabled,
        isSelectable,
        isLoading,
        isExpandable,
        breakingSizeQuery,
      },
      ref
    ) => {
      const [expanded, setExpanded] = useState(isInitialyExpanded);

      const handleSelectedCard = (e) => {
        if (!isSelectable) return;
        handleSelect && handleSelect(e);
      };

      const handleExpandCard = (e) => {
        setExpanded((prevState) => !prevState);
        e.stopPropagation();
      };

      const cardClass = classNames(className, {
        selected: isSelected,
        expanded: isSelected || expanded,
      });

      return (
        <div className={cardClass} ref={ref} onClick={handleSelectedCard}>
          <div className="card-loader">
            <Shimmer className="shimmer"></Shimmer>
            {loaderContent}
          </div>
          <div className="card-content">{children}</div>
          {!isLoading && expandedContent && (
            <>
              <div className="arrow">
                <Icon src={ExpandCardIcon(expanded)} onClick={handleExpandCard} />
              </div>
              <div className="expanded-content">{expandedContent}</div>
            </>
          )}
        </div>
      );
    }
  )
)`
  ${styles.Card}
`;

Card.defaultProps = {
  appearance: 'regular',
  isSelected: false,
  isInitialyExpanded: false,
  isDisabled: false,
  isSelectable: false,
  isLoading: false,
  isExpandable: false,
};
